import { Provider } from "react-redux";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerAppCallbacks } from "./callbacks/registerCallbacks";
import { router } from "./router";
import { store } from "./store/store";
import { initI18n } from "./shared/i18n/i18n";
import { serialList } from "./widgets/common/serialList/state";
import "echart-table-library/styles.css";
import "./index.css";

// Register business $callbacks once at startup (D4).
registerAppCallbacks();

// App-wide reference data (machine serial list): fetch exactly once per
// session at startup — whichever page is opened first. Pages consume the
// Redux cache through `useSerialList` (its status guard skips this request).
void store.dispatch(serialList.fetch());

// i18next with the JSON translations (shared/i18n/locales/*.json), seeded
// from the persisted Redux locale; the LanguageSwitcher changes it later.
initI18n(store.getState().locale.value);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </StrictMode>,
);
